import { Exclude } from 'class-transformer'

export class ResponseDto {
  @Exclude()
  tid!: string

  @Exclude()
  ts!: number
}
